<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        Total
        <DoughnutChart v-if="!loading" chartId="total" :count="summary.total" color="#ffc107"/>
      </b-col>
      <b-col>
        Sync to Pattern ( {{ (summary.total_pattern / summary.total * 100).toFixed(1) }} % )
        <DoughnutChart v-if="!loading" chartId="batch" :count="summary.total_pattern" color="#e71e07"/>
      </b-col>
      <b-col>
        Obfuscated
        <DoughnutChart v-if="!loading" chartId="normal" :count="summary.total" color="#000080"/>
      </b-col>
      <b-col>
        Webshell
        <DoughnutChart v-if="!loading" chartId="done" :count="summary.total_webshell" color="#f86b6b"/>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col>
        <table class="w-100 table text-center">
          <thead>
            <th class="m-2 p-2" colspan="1"></th>
            <th class="m-2 p-2">asp</th>
            <th class="m-2 p-2">jsp</th>
            <th class="m-2 p-2">perl</th>
            <th class="m-2 p-2">php</th>
            <th class="m-2 p-2">python</th>
            <th class="m-2 p-2">ruby</th>
            <th class="m-2 p-2">javascript</th>
            <th class="m-2 p-2">java</th>
            <th class="m-2 p-2">etc</th>
            <th class="m-2 p-2">Total</th>
          </thead>
          <tbody>
            <tr class="text-danger font-weight-bold">
              <td>Total</td>
              <td> {{ summary.webshell.asp | number }} </td>
              <td> {{ summary.webshell.jsp | number }} </td>
              <td> {{ summary.webshell.perl | number }} </td>
              <td> {{ summary.webshell.php | number }} </td>
              <td> {{ summary.webshell.python | number }} </td>
              <td> {{ summary.webshell.ruby | number }} </td>
              <td> {{ summary.webshell.javascript | number }} </td>
              <td> {{ summary.webshell.java | number }} </td>
              <td> {{ summary.webshell.etc | number }} </td>
              <td> {{ summary.total | number }} </td>
            </tr>
            <tr>
              <td>%</td>
              <td> {{ percent('webshell', summary.webshell.asp) }} </td>
              <td> {{ percent('webshell', summary.webshell.jsp) }} </td>
              <td> {{ percent('webshell', summary.webshell.perl) }} </td>
              <td> {{ percent('webshell', summary.webshell.php) }} </td>
              <td> {{ percent('webshell', summary.webshell.python) }} </td>
              <td> {{ percent('webshell', summary.webshell.ruby) }} </td>
              <td> {{ percent('webshell', summary.webshell.javascript) }} </td>
              <td> {{ percent('webshell', summary.webshell.java) }} </td>
              <td> {{ percent('webshell', summary.webshell.etc) }} </td>
              <td> {{ percent('webshell', summary.total) }} </td>

            </tr>

          </tbody>
        </table>
      </b-col>
    </b-row>
    <!-- {{ summary }} -->
  </div>
</template>

<script>
// import vSelect from 'vue-select';
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
// import datepicker from '@/f1/custom';
import { api, auth } from '@/f1/service';
import 'vue2-datepicker/index.css';
// import config from '@/f1/config'
import moment from 'moment-timezone';
// import _ from 'lodash';

// component
import DoughnutChart from '@/f1/views/dashboard/components/DoughnutChart.vue'

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt: {
    created_at_ed: moment().add(1, 'd'),
    created_at_sd: moment().add(1, 'd'),
  }, adv: false,
  pageoptions: [
    { text: '10 rows', value: 10 },
    { text: '25 rows', value: 25 },
    { text: '50 rows', value: 50 },
    { text: '100 rows', value: 100 },
    { text: '200 rows', value: 200 }
  ]
});

export default {
  components: { DatePicker, DoughnutChart },
  data: () => ({
    loading: false,
    summary : { normal: 0, total: 0, done: 0, batch: 0, webshell : 0 },
    so: default_opt(),
    profile: auth.profile
  }),
  computed: {
  },
  methods: {
    percent(x = 0) {

      return this.summary.total === 0 ? 0 : (x / this.summary.total * 100).toFixed(2)

      // if(type == 'normal') {
      //   return this.summary.normal.total === 0 ? 0 : (x / this.summary.normal.total * 100).toFixed(2)
      // } else if (type == 'webshell') {

      // } else {
      //   return (this.summary.webshell.total + this.summary.webshell.normal) === 0 ? 0 : (x / (this.summary.webshell.total + this.summary.normal.total) * 100).toFixed(1)
      // }

    },
    async load() {
      this.loading = true;
      try {
        let rs = await api.dms.webshell.summary();

        this.summary = Object.assign({}, this.summary, rs)

      } catch (e) { this.$toastr.e(e.data || e); }
      finally {
        this.loading = false;
      }
    },
  },
  created() { },
  destroyed() { },
  mounted() { this.load() },
}
</script>
<style>

.spinner {
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

